import { safeJsonStringify } from "./utils/htmlEscape";

var _process_env_ONE_CACHE_KEY;
var isWebClient = false;
var isWebServer = false;
var isNative = true;
var hasWebHistory = false && typeof window.history !== "undefined" && typeof window.location !== "undefined";
var CACHE_KEY = `${(_process_env_ONE_CACHE_KEY = process.env.ONE_CACHE_KEY) !== null && _process_env_ONE_CACHE_KEY !== void 0 ? _process_env_ONE_CACHE_KEY : Math.round(Math.random() * 1e8)}`;
var LOADER_JS_POSTFIX_UNCACHED = `_vxrn_loader.js`;
var LOADER_JS_POSTFIX_REGEX_STRING = `_\\d+${LOADER_JS_POSTFIX_UNCACHED}$`;
var LOADER_JS_POSTFIX_REGEX = new RegExp(LOADER_JS_POSTFIX_REGEX_STRING);
var LOADER_JS_POSTFIX = `_${CACHE_KEY}${LOADER_JS_POSTFIX_UNCACHED}`;
var PRELOAD_JS_POSTFIX = `_${CACHE_KEY}_preload.js`;
var CSS_PRELOAD_JS_POSTFIX = `_${CACHE_KEY}_preload_css.js`;
var PRELOAD_JS_POSTFIX_REGEX = /_\d+_preload\.js$/;
var CSS_PRELOAD_JS_POSTFIX_REGEX = /_\d+_preload_css\.js$/;
function setCacheKey(key) {
	if (!key || key === CACHE_KEY) return;
	CACHE_KEY = key;
	LOADER_JS_POSTFIX = `_${CACHE_KEY}${LOADER_JS_POSTFIX_UNCACHED}`;
	PRELOAD_JS_POSTFIX = `_${CACHE_KEY}_preload.js`;
	CSS_PRELOAD_JS_POSTFIX = `_${CACHE_KEY}_preload_css.js`;
}
var VIRTUAL_SSR_CSS_ENTRY = `virtual:ssr-css.css`;
var VIRTUAL_SSR_CSS_HREF = `/@id/__x00__${VIRTUAL_SSR_CSS_ENTRY}`;
var SERVER_CONTEXT_KEY = "__one_server_context__";
var getSpaHeaderElements = function getSpaHeaderElements2() {
	var { serverContext = {} } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
	return `
  <script>globalThis['global'] = globalThis<\/script>
  <script>globalThis['__vxrnIsSPA'] = true<\/script>
  <script>globalThis["${SERVER_CONTEXT_KEY}"] = ${safeJsonStringify(serverContext)}<\/script>
  <script>globalThis.__oneLoadedCSS = new Set(${safeJsonStringify(serverContext.css || [])})<\/script>
`;
};

export { CACHE_KEY, CSS_PRELOAD_JS_POSTFIX, CSS_PRELOAD_JS_POSTFIX_REGEX, LOADER_JS_POSTFIX, LOADER_JS_POSTFIX_REGEX, LOADER_JS_POSTFIX_REGEX_STRING, LOADER_JS_POSTFIX_UNCACHED, PRELOAD_JS_POSTFIX, PRELOAD_JS_POSTFIX_REGEX, SERVER_CONTEXT_KEY, VIRTUAL_SSR_CSS_ENTRY, VIRTUAL_SSR_CSS_HREF, getSpaHeaderElements, hasWebHistory, isNative, isWebClient, isWebServer, setCacheKey };